<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>KPI考核</el-breadcrumb-item>
            <el-breadcrumb-item>指标名称管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left">
        <el-col :span="24">
          <el-form
            :model="searchForm"
            :inline="true"
            class="demo-form-inline"
            size="small"
          >
            <el-form-item>
              <el-select
                filterable
                v-model="searchForm.pid"
                clearable
                size="small"
                placeholder="--请选择类型--"
              >
                <el-option
                  v-for="(item, index) in winOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                size="small"
                clearable
                v-model="searchForm.title"
                placeholder="名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="quotaSearch"
                >搜索</el-button
              >
            </el-form-item>
            <el-form-item style="float:right">
              <el-button type="primary" size="small" @click="quotaAdd"
                >添加</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="quotaType" style="width: 100%">
            <el-table-column label="类型">
              <template slot-scope="scope">
                <span>{{ scope.row.typeName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="名称">
              <template slot-scope="scope">
                <span>{{ scope.row.ClassName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="排序">
              <template slot-scope="scope">
                <span>{{ scope.row.Sort }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row.Id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top:10px">
            <el-col :span="24">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog title="添加信息" :visible.sync="dialogFormVisible">
      <el-form :model="dialogForm">
        <el-form-item label="名称">
          <el-input
            v-model="dialogForm.ClassName"
            autocomplete="off"
            style="width:90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select
            filterable
            v-model="dialogForm.ParentId"
            clearable
            style="width:90%"
            placeholder="--请选择类型--"
          >
            <el-option
              v-for="(item, index) in winOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelDialog">取 消</el-button>
        <el-button type="primary" @click="handleChangeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetQuotanameList,
  EditSingleQuota,
  DeleteSingleQuota,
  GetSingleQuota
} from "../../until/ZeusApiSDK/Logic/KPISettingLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";

export default {
  components: {},
  computed: {
    quotaType: function() {
      this.tableData.forEach(item => {
        switch (item.ParentId) {
          case "10":
            item.typeName = "业绩指标";
            break;
          case "11":
            item.typeName = "客户指标";
            break;
          case "12":
            item.typeName = "敬业度";
            break;
          default:
            item.typeName = "团队管理";
            break;
        }
      });
      return this.tableData;
    }
  },
  data() {
    return {
      winOptions: [
        { label: "业绩指标", value: "10" },
        { label: "客户指标", value: "11" },
        { label: "敬业度", value: "12" },
        { label: "团队管理", value: "13" }
      ],
      searchForm: {
        pid: "",
        title: ""
      },
      tableData: [],
      pageSizes: [10, 20, 30, 50],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 200,
      // 弹窗dialog
      dialogFormVisible: false,
      dialogForm: {},
      param: {},
      user: {},
      singleData: {}
    };
  },
  created() {
    this.GetQuotanameList();
    this.user = GetCurrentUserInfo();
  },
  methods: {
    //获取列表API
    GetQuotanameList: async function() {
      //获取部门信息
      await GetQuotanameList(
        this.searchForm.pid,
        this.pageIndex,
        this.pageSize,
        this.searchForm.title
      ).then(res => {
        this.tableData = res.Data.DataList;
        this.totalCount = res.Data.totalCount;
      });
    },
    // 添加/编辑单个API
    EditSingleQuota: async function(param) {
      await EditSingleQuota(param).then(res => {
        if (res.Code === 200) {
          this.$message({
            type: "success",
            message: "添加成功~"
          });
          this.cancelDialog();
          // 刷新列表
          this.GetQuotanameList();
        }
      });
    },
    // 删除单个API
    DeleteSingleQuota: async function(userCode, id) {
      await DeleteSingleQuota(userCode, id).then(res => {
        if (res.Code === 200) {
          this.$message({
            type: "success",
            message: "删除成功~"
          });
          this.cancelDialog();
          // API请求成功后,清空表单
          // 刷新列表
          this.GetQuotanameList();
        }
      });
    },
    quotaSearch() {
      // 初始化page页面
      this.initPage();
      // 执行搜索api
      this.GetQuotanameList();
    },
    quotaAdd() {
      // 清空内容
      this.dialogForm = {};
      this.dialogForm = {
        id: "",
        ClassName: "",
        Sort: null,
        ParentId: "",
        userCode: this.user.UserCode
      };
      // 打开弹窗
      this.openDialog();
    },
    handleEdit(index, row) {
      // 获取id,请求内容
      console.log(index, row, "编辑");
      this.dialogForm = {
        id: row.Id,
        ClassName: row.ClassName,
        Sort: row.Sort,
        ParentId: row.ParentId,
        userCode: this.user.UserCode
      };
      // 打开弹窗
      this.openDialog();
      // 点击取消 -> 弹窗清空
      // 点击确定-> 提交单个修改 -> 更新列表
    },
    handleDelete(index, row) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.DeleteSingleQuota(this.user.UserCode, row);
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.GetQuotanameList();
    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.GetQuotanameList();
    },
    handleCancelDialog() {
      // 关闭弹窗
      this.cancelDialog();
      // 清空表单
      this.dialogForm = {};
    },
    handleChangeDialog() {
      if (this.dialogForm.ClassName === "") {
        this.$message({
          type: "error",
          message: "请填写指标名称~"
        });
        return false;
      }
      if (this.dialogForm.ParentId === "") {
        this.$message({
          type: "error",
          message: "请选择指标类别~"
        });
        return false;
      }
      // 关闭弹窗
      this.EditSingleQuota(this.dialogForm);
    },
    openDialog() {
      // 关闭弹窗
      this.dialogFormVisible = true;
    },
    cancelDialog() {
      this.dialogFormVisible = false;
    },
    initPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.sub {
  font-size: 12px;
  color: #8f8d8d;
  text-align: left;
  /* margin-top: 10px; */
}
/deep/.contentP {
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/.mainArea {
  margin: 20px;
  height: 30%;
}
/deep/.bottomInput {
  display: inline;
}
/deep/.web__main-user img {
  margin-top: 18px;
}
</style>
